<template>
	<div>
		<div
			class="archivetest-list-cards d-flex align-items-center mt-2"
			:class="test.view || test.clone ? 'archivechangecolor' : ''"
		>
			<div class="gridredcolordynamic"></div>
			<div style="width: 60%" class="ml-3">
				<div class="archivelist-topictxt text-truncate">
					<span v-b-popover.hover.top="test.topicName">{{
						test.topicName
					}}</span>
				</div>
				<div class="archivelist-testtxt mt-1 text-truncate">
					<span v-b-popover.hover.bottom="test.testName">{{
						test.testName
					}}</span>
				</div>
			</div>
			<div style="width: 10%">
				<div class="d-flex flex-column">
					<span class="tp-cardhead">Sections</span>
					<span class="greennumbertext">{{ test.numberOfSections }}</span>
				</div>
			</div>
			<div style="width: 10%">
				<div class="d-flex flex-column">
					<span class="tp-cardhead">Marks</span>
					<span class="yellownumbertext">{{ test.marks }}</span>
				</div>
			</div>
			<div style="width: 20%">
				<div class="d-flex justify-content-end align-items-center">
					<img
						v-if="test.publicAvailability"
						v-b-popover.hover.top="'Public'"
						src="../../assets/icons/Archivetest/greenlock.svg"
						alt=""
					/>
					<img
						v-b-popover.hover.top="'Private'"
						v-if="!test.publicAvailability"
						src="../../assets/icons/Archivetest/redlock.svg"
						alt=""
					/>
					<img
						v-if="roles.includes('ACTIVATE_TEST')"
						v-b-popover.hover.top="'Clone Test'"
						@click="
							toggleview('clone', test.testID),
								$emit('archivetestmodal', {
									testID: test.testID,
									name: test.testName,
									publicAvailability: test.publicAvailability,
								})
						"
						src="../../assets/icons/Archivetest/archivetagtest.svg"
						alt=""
						class="ml-2 pointer"
					/>
					<img
						v-b-popover.hover.top="'Preview'"
						v-if="
							!test.view &&
								this.roles.includes('GET_QUESTION') &&
								this.roles.includes('GET_SECTION')
						"
						@click="toggleview('view', test.testID), saveTestPreview()"
						src="../../assets/icons/Archivetest/vieweye.svg"
						class="ml-2 mr-3 pointer"
						alt=""
					/>
					<img
						v-b-popover.hover.top="'Close'"
						v-else-if="
							this.roles.includes('GET_QUESTION') &&
								this.roles.includes('GET_SECTION')
						"
						@click="toggleview('view', null), $emit('toggleTestPreview', false)"
						src="../../assets/visibility_off.svg"
						class="ml-2 mr-3 pointer"
						alt=""
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "Archivedlistview",
	data() {
		return {};
	},
	props: {
		test: Object,
	},
	computed: {
		...mapGetters(["roles"]),
	},
	methods: {
		async saveTestPreview() {
			this.$emit("toggleTestPreview", true);
			this.$store.commit("autotestVUEX/saveSelectedAutoTest", this.test);
			await this.$store.dispatch("sectionVUEX/getSection", this.test.testID);
		},
		toggleview(key, data) {
			this.$emit("toggleview", key, data);
		},
	},
};
</script>

<style>
.archivechangecolor {
	border: 2px solid #84bae7;
	border-radius: 8px;
	background: #ebf5fe !important;
}
.gridredcolordynamic {
	width: 4px;
	height: 70px;
	border-radius: 2px;
	position: absolute;
	background: red;
	left: 2px;
	top: 5px;
}
</style>
